import { apiClient } from './api'

export type PortfolioStatus = 'planning' | 'active' | 'on_hold' | 'completed' | 'archived'

export interface Portfolio {
  id: number
  name: string
  description: string | null
  status: PortfolioStatus
  organization_id: number | null
  owner_id: number | null
  start_date: string | null
  end_date: string | null
  metadata?: Record<string, unknown>
  created_at: string
  updated_at: string
}

export interface PortfolioCreate {
  name: string
  description?: string
  status?: PortfolioStatus
  start_date?: string
  end_date?: string
  owner_id?: number
  organization_id?: number
  metadata?: Record<string, unknown>
}

export interface PortfolioUpdate {
  name?: string
  description?: string
  status?: PortfolioStatus
  start_date?: string
  end_date?: string
  owner_id?: number
  metadata?: Record<string, unknown>
}

export const portfoliosService = {
  /**
   * List portfolios
   */
  async list(params?: { skip?: number; limit?: number; status?: string; include_deleted?: boolean }): Promise<Portfolio[]> {
    const response = await apiClient.get<Portfolio[]>('/api/v1/portfolios', { params })
    return response.data
  },

  /**
   * Get portfolio by ID
   */
  async get(id: number): Promise<Portfolio> {
    const response = await apiClient.get<Portfolio>(`/api/v1/portfolios/${id}`)
    return response.data
  },

  /**
   * Create portfolio
   */
  async create(data: PortfolioCreate): Promise<Portfolio> {
    const response = await apiClient.post<Portfolio>('/api/v1/portfolios', data)
    return response.data
  },

  /**
   * Update portfolio
   */
  async update(id: number, data: PortfolioUpdate): Promise<Portfolio> {
    const response = await apiClient.put<Portfolio>(`/api/v1/portfolios/${id}`, data)
    return response.data
  },

  /**
   * Delete portfolio
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/v1/portfolios/${id}`)
  },

  /**
   * Restore portfolio
   */
  async restore(id: number): Promise<Portfolio> {
    const response = await apiClient.post<Portfolio>(`/api/v1/portfolios/${id}/restore`)
    return response.data
  },
}

